<template>
  <!-- TODO: 增加智能回复：机器人知识库、内部知识库、知识库文章、附件等 -->
  <!-- TODO: 支持iframe形式，将客户自己的URL网址 嵌入到右侧tab -->
  <div id="bd-thread-right">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="customerInfoTip" name="info">
        <bd-info></bd-info>
      </el-tab-pane>
      <el-tab-pane :label="cuwTip" name="cuw">
        <bd-cuw style="margin-top: 15px;"></bd-cuw>
      </el-tab-pane>
      <el-tab-pane :label="commodityTip" name="commodity">
        <bd-commodity></bd-commodity>
      </el-tab-pane>
      <el-tab-pane :label="otherTip" name="other">
        <el-tabs v-model="otherActiveName">
          <el-tab-pane :label="historyThreadTip" name="thread">
            <bd-thread></bd-thread>
          </el-tab-pane>
          <el-tab-pane :label="webrtcTip" name="rtc">
            <bd-rtc></bd-rtc>
          </el-tab-pane>
          <el-tab-pane
            v-if="showAuthority.debug"
            :label="ticketTip"
            name="ticket"
          >
            <bd-ticket></bd-ticket>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <!--<el-tab-pane v-if="showAuthority.debug" :label="knowledgeTip" name="support">
        <bd-support></bd-support>
      </el-tab-pane>-->
      <!-- <el-tab-pane :label="deviceTip" name="device">
        <bd-device></bd-device>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BdCommodity from "@/components/dashboard/main/chat/right/BdCommodity";
import BdCuw from "@/components/dashboard/main/chat/right/BdCuw";
import BdInfo from "@/components/dashboard/main/chat/right/BdInfo";
// import BdDevice from '@/components/dashboard/main/chat/right/BdDevice'
// import BdSupport from '@/components/dashboard/main/chat/right/BdSupport'
import BdThread from "@/components/dashboard/main/chat/right/BdThread";
import BdRtc from "@/components/dashboard/main/chat/right/BdRTC";
import BdTicket from "@/components/dashboard/main/chat/right/BdTicket";
import bus from "@/util/eventbus";
const constants = require("@/util/constants");

export default {
  name: "bd-thread-right",
  components: { BdCommodity, BdCuw, BdInfo, BdThread, BdRtc, BdTicket }, // BdDevice, BdSupport,
  data() {
    return {
      activeName: "cuw",
      otherActiveName: "thread",
      // showRTCTab: true // 为方便测试设置为true
    };
  },
  computed: {
    ...mapGetters(["userCurrentThread", "commodityMessages", "showAuthority"]),
    username() {
      return this.userCurrentThread.visitor.username;
    },
    customerInfoTip() {
      return this.$t("customerInfo");
    },
    cuwTip() {
      return this.$t("cuw");
    },
    historyThreadTip() {
      return this.$t("historyThread");
    },
    ticketTip() {
      return this.$t("tickets");
    },
    deviceTip() {
      return this.$t("deviceInfo");
    },
    commodityTip() {
      return this.$t("commodity");
    },
    knowledgeTip() {
      return this.$t("knowledge");
    },
    webrtcTip() {
      return this.$t("webrtc");
    },
    otherTip() {
      return this.$t("other");
    },
  },
  methods: {
    ...mapActions(["getCuws", "updateRightActiveTab", "getMessagesCommodity"]),
    handleClick(tab, event) {
      // console.log('top tab:', tab.name)
      this.updateRightActiveTab(tab.name)
      if (tab.name === "info") {
        //
      } else if (tab.name === "cuw") {
        //
      } else if (tab.name === "commodity") {
        this.getMessagesCommodity()
      } else if (tab.name === 'other') {
        // 
      }
    },
  },
  mounted() {
    this.getCuws();
    // 本地消息通知
    bus.$on(constants.EVENT_BUS_WEBRTC_ACCEPT, (message) => {
      // console.log("right eventbus: ", message);
      // this.showRTCTab = true
      this.activeName = "other";
      this.otherActiveName = "rtc";
    });
    // 点击消息添加到快捷回复
    bus.$on(constants.EVENT_BUS_ADD_MESSAGE_TO_CUW, (message) => {
      // console.log("type:" + message.type);
      this.activeName = "cuw";
    });
  },
};
</script>

<style scoped>
#bd-thread-right {
  height: 100%;
  width: 100%;
}
.el-tabs {
  height: 100%;
  width: 100%;
  margin-left: 8px;
}
.el-tab-pane {
  padding: 0px 10px 5px 10px;
  height: calc(100% - 100px) !important;
}
.el-tabs__content {
  height: 100% !important;
  overflow-y: scroll !important;
}
</style>
